export const INDIAN_STANDARD_DATE = "DD/MM/YYYY"
export const INDIAN_STANDARD_DATE_WITH_MONTH = "DD MMM YYYY"
export const ISO_STANDARD_DATE = "YYYY-MM-DD"
export const INDIAN_STANDARD_DATE_TIME = "DD MMM YYYY | hh:mm A"
